module.exports = __webpack_public_path__ + "static/media/plant.8205b98f.gif";